import { Component, Input, OnInit } from '@angular/core';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { FormControl } from '@angular/forms';
import { SelectFieldComponent } from '../../select-field/select-field.component';
import { CompaniesService } from 'src/app/services/api/general-settings/companies.service';

@Component({
  selector: 'select-company-field',
  imports: [SelectFieldComponent],
  templateUrl: './select-company-field.component.html',
  styleUrl: './select-company-field.component.scss'
})
export class SelectCompanyFieldComponent implements OnInit {
  @Input() label?: string;
  @Input() selectFormControl!: FormControl
  @Input() readonly!: boolean
  @Input() preloadedCompanies?: any[];

  companies: any[] = [];

  options: { key: string, value: string }[] = []

  constructor(
    private companiesService: CompaniesService,
    private alertNotificationService: AlertNotificationService
  ) { }

  ngOnInit(): void {
    if (this.preloadedCompanies) {
      this.companies = this.preloadedCompanies;
      this.options = this.mapCompaniesToOptions(this.companies);
    } else {
      this.loadData()
    }
  }

  public loadData(): void {
    this.companiesService.list()?.subscribe({
      next: (response: any) => {
        if (response?.data?.companies) {
          this.companies = response.data.companies;
          this.options = this.mapCompaniesToOptions(this.companies);
        }
      },
      error: (error: any) => {
        console.error('Error while loading Companies:', error);
        this.alertNotificationService.error('Error while loading Companies');
      }
    });
  }

  private mapCompaniesToOptions(companies: any[]): { key: string, value: string }[] {
    return [
      { key: 2, value: 'ALL COMPANIES' },
      ...companies.map((c: any) => ({
        key: c.companyId,
        value: c.name
      }))
    ];
  }
}
